import s from "./AffirmBadge.module.css";

const CDN = "https://d2naapwr4zpnvs.cloudfront.net/misc";

export default function AffirmBadge() {
  return (
    <div className={s.root}>
      <div className={s.logos}>
        <img
          className={s.logo}
          src={`${CDN}/affirm.png`}
          alt="Affirm"
          loading="lazy"
          width="42"
          height="24"
        />
        <img
          className={s.logo}
          src={`${CDN}/klarna.png`}
          alt="Klarna"
          loading="lazy"
          width="70"
          height="48"
        />
        <img
          className={s.logo}
          src={`${CDN}/afterpay.png`}
          alt="Afterpay"
          loading="lazy"
          width="72"
          height="40"
        />
      </div>
      <span className={s.label}>Pay in installments</span>
    </div>
  );
}
